import { useUnitAssignment } from '../../unit-assignment/unit-assignment-context';
import { useApplicationType } from '../../common/hooks/use-application-type';

export function useIsLinkToAssignedEventCheckboxVisible() {
    const unitAssignment = useUnitAssignment();
    const { isFirstResponder } = useApplicationType();

    return !!(isFirstResponder && unitAssignment?.unitId && unitAssignment?.assignedEvent);
}
